import { Snackbar, Alert } from "@mui/material";

const SnackbarAlert = ({ open, message, severity, handleClose }) => {
    return (
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert
                onClose={handleClose}
                severity={severity}
                sx={{
                    width: '100%',
                    borderRadius: '10px', // Rounded corners
                    fontSize: '0.8rem', // Font size set to 0.7rem
                    paddingX: '14px', // Adjust padding for better text alignment
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default SnackbarAlert;
